export enum AuthenticationType {
    Entra = 'Entra',
    Salesforce = 'Salesforce',
}

export interface Environment {
    name: string;
    authenticationType?: AuthenticationType | string;
    auth?: AuthConfig;
    msal?: B2CPolicies;
    api?: APIModel;
    configurationName?: string;
    i18n?: I18nModel;
}

export interface AuthConfig {
    clientId: string;
    issuer: string;
    scope?: string;
    /**
     * OIDC check-session iframe polling. Default false — see createAuthClientConfig.
     * Set true only in environments where sessionTracker is stable (no extension noise).
     */
    checkSessionEnabled?: boolean;
}

export interface B2CPolicies {
    name: string;
    tenantId: string;
    applicationClientId: string;
    redirectUri: string;
    b2cTenantName: string;
}

export interface APIModel {
    basePath: string;
    applicationId: string;
}

export interface I18nModel {
    useFallbackTranslation: boolean;
    fallbackLanguage: string;
    prodMode: boolean;
}

export enum EnvironmentName {
    DEV = 'dev',
    PROD = 'prod',
    STAGE = 'stage',
    FEAT = 'feat',
    LOCAL = 'local',
}

export function isSalesforceAuth(config: Environment): boolean {
    return config.authenticationType === AuthenticationType.Salesforce;
}
